/**
 * @file routes/_app/auditor/route.tsx
 * @description 稽核員專區 Layout 路由（M2）。
 */

import { Outlet, createFileRoute } from '@tanstack/react-router';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/auditor')({
  component: () => <Outlet />,
});
